import React from 'react';
import { useTranslation } from '@/hooks/useTranslation';

const LanguageSwitcher = () => {
  const { currentLanguage, changeLanguage } = useTranslation();

  const handleLanguageChange = (e) => {
    changeLanguage(e.target.value);
  };

  return (
    <select 
      value={currentLanguage} 
      onChange={handleLanguageChange}
      className="bg-transparent text-white border border-provatio-gold/50 rounded-md px-2 py-1 text-sm outline-none focus:border-provatio-gold appearance-none cursor-pointer"
    >
      <option value="pt" className="text-black">🇧🇷 PT</option>
      <option value="en" className="text-black">🇺🇸 EN</option>
      <option value="es" className="text-black">🇪🇸 ES</option>
    </select>
  );
};

export default LanguageSwitcher;